import { render, staticRenderFns } from "./WalletWithShopping.vue?vue&type=template&id=365fda59&"
import script from "./WalletWithShopping.vue?vue&type=script&lang=js&"
export * from "./WalletWithShopping.vue?vue&type=script&lang=js&"
import style0 from "./WalletWithShopping.vue?vue&type=style&index=0&id=365fda59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports